<ng-container *ngIf="broadcastMessages$ | async as broadcasts">
    <app-broadcast-banner-list [broadcastMessages]="broadcasts" [showHideButton]="showHideButton"></app-broadcast-banner-list>
</ng-container>
